module.exports = __webpack_public_path__ + "static/img/buy1.4bef6dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buy1.png
// module id = XI2x
// module chunks = 1